import * as MobileHomePermitFields from '@src/permitField/MobileHomeFields';
import { BooleanField } from '@src/permitField/PermitFields';

export class LoadIsMobileHomeField extends BooleanField {
  public static fieldName: string =
    MobileHomePermitFields.LoadIsMobileHomeField.fieldName;
}

export class IsUsedMobileHomeField extends BooleanField {
  public static fieldName: string =
    MobileHomePermitFields.IsUsedMobileHomeField.fieldName;
}

export class MobileHomeYearField extends BooleanField {
  public static fieldName: string =
    MobileHomePermitFields.MobileHomeYearField.fieldName;
}

export class MobileHomeMakeField extends BooleanField {
  public static fieldName: string =
    MobileHomePermitFields.MobileHomeMakeField.fieldName;
}

export class MobileHomeSerialNumberField extends BooleanField {
  public static fieldName: string =
    MobileHomePermitFields.MobileHomeSerialNumberField.fieldName;
}

export class MobileHomeHitchLengthField extends BooleanField {
  public static fieldName: string =
    MobileHomePermitFields.MobileHomeHitchLengthField.fieldName;
}

export class MobileHomeEaveWidthField extends BooleanField {
  public static fieldName: string =
    MobileHomePermitFields.MobileHomeEaveWidthField.fieldName;
}

export class MobileHomeBoxWidthField extends BooleanField {
  public static fieldName: string =
    MobileHomePermitFields.MobileHomeBoxWidthField.fieldName;
}

export class MobileHomeBoxLengthField extends BooleanField {
  public static fieldName: string =
    MobileHomePermitFields.MobileHomeBoxLengthField.fieldName;
}

export class MobileHomeRoadsideEavesLengthField extends BooleanField {
  public static fieldName: string =
    MobileHomePermitFields.MobileHomeRoadsideEavesLengthField.fieldName;
}

export class MobileHomeCurbsideEavesLengthField extends BooleanField {
  public static fieldName: string =
    MobileHomePermitFields.MobileHomeCurbsideEavesLengthField.fieldName;
}

export class MobileHomeHudNumberField extends BooleanField {
  public static fieldName: string =
    MobileHomePermitFields.MobileHomeHudNumberField.fieldName;
}
